import { render, staticRenderFns } from "./comp0.vue?vue&type=template&id=04c64365&scoped=true"
import script from "./comp0.vue?vue&type=script&lang=ts"
export * from "./comp0.vue?vue&type=script&lang=ts"
import style0 from "./comp0.vue?vue&type=style&index=0&id=04c64365&prod&scoped=true&lang=scss"
import style1 from "./comp0.vue?vue&type=style&index=1&id=04c64365&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c64365",
  null
  
)

export default component.exports